import {
    OBTENER_DASHBOARD,
    MARCA_ERROR,
    MARCA_OK,
} from 'types/context';

export default (state, action) => {
    switch (action.type) {
        case OBTENER_DASHBOARD:
            return {
                ...state,
                widgets: action.payload
            }
        case MARCA_ERROR:
            return {
                ...state,
                mensaje: action.payload
            }
        case MARCA_OK:
            return {
                ...state,
                mensaje: action.payload
            }       
        default:
            return state;
    }
}